import { IndexedDBService } from "../../../../services/indexed-db-service";

export const MultiSelectDB = new IndexedDBService("MultiSelectCache", "MultiSelectOpts");
export const SingleSelectDB = new IndexedDBService("SingleSelectCache", "SingleSelectOpts");
